import { put, select } from 'redux-saga/effects';

import * as actions from '../../actions';

import addQuestionChoice from './addQuestionChoice';

export default function*(action) {
  const surveysState = yield select(state => state.surveys);

  if (surveysState.activeFlow && !surveysState.activeFlow.flows) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api('updateQuestion', newSurveyStateActiveFlow);
  }

  const newState = addQuestionChoice(
    surveysState,
    action.flowId,
    action.customAttributes,
    action.isOther,
    action.isNoneOfTheAbove
  );
  yield put({ type: actions.SET_NEW_STATE, newState: newState.newState });
}
